import { render, staticRenderFns } from "./PlacementsEndComponentPerformanceItem.vue?vue&type=template&id=8949b66c&"
import script from "./PlacementsEndComponentPerformanceItem.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentPerformanceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports